<template>

    <Transition name="web-faq-slide">
                <div id="faqCatContainer" class="pb-3 text-center d-flex flex-wrap w-100 mx-auto justify-content-center" style="max-width: 700px;">

                    <CategoryCard v-for="category in categories" :key="category.id" :category="category"
                        :selectCat="selectCat" :selected="selected" />
                </div>

    </Transition>
</template>
<script>
import CategoryCard from './CategoryCard.vue';


export default {
    props: { categories: { type: Array }, selectCat: { type: Function }, selected: { type: Object } },

    components: { CategoryCard },

    data() {
        return {
        }
    },

    methods: {


    }
}
</script>